export const LOGIN = "LOGIN"
export const LOGOUT = "LOGOUT"
export const EDIT_PROFILE = "EDIT_PROFILE"
export const SHOW_LOGIN_MODAL = "SHOW_LOGIN_MODAL"
export const HIDE_LOGIN_MODAL = "HIDE_LOGIN_MODAL"
export const FILL_REGISTER_DETAILS = "FILL_REGISTER_DETAILS"
export const TOGGLE_EDIT_PROFILE_MODAL = "TOGGLE_EDIT_PROFILE_MODAL"
export const OPEN_EDIT_PROFILE_MODAL = "OPEN_EDIT_PROFILE_MODAL"
export const TOGGLE_BOOK_TABLE_MODAL = "TOGGLE_BOOK_TABLE_MODAL"